import light from './_lightMuiTheme'
import dark from './_darkMuiTheme'

const themes = {
  light,
  dark,
}

const getTheme = ({ type, theme }) => {
  return themes[type](theme)
}

export default getTheme
